const Usdt = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z'
				fill='#26A17B'
			/>
			<path
				d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
				stroke='white'
				strokeOpacity='0.2'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M17.922 17.3831V17.3811C17.812 17.3891 17.245 17.4231 15.98 17.4231C14.97 17.4231 14.259 17.3931 14.009 17.3811V17.3841C10.121 17.2131 7.21905 16.5361 7.21905 15.7261C7.21905 14.9171 10.121 14.2401 14.009 14.0661V16.7101C14.263 16.7281 14.991 16.7711 15.997 16.7711C17.204 16.7711 17.809 16.7211 17.922 16.7111V14.0681C21.802 14.2411 24.697 14.9181 24.697 15.7261C24.697 16.5361 21.802 17.2111 17.922 17.3831ZM17.922 13.7931V11.4271H23.336V7.81909H8.59505V11.4271H14.009V13.7921C9.60905 13.9941 6.30005 14.8661 6.30005 15.9101C6.30005 16.9541 9.60905 17.8251 14.009 18.0281V25.6101H17.922V18.0261C22.3151 17.8241 25.616 16.9531 25.616 15.9101C25.616 14.8671 22.3151 13.9961 17.922 13.7931Z'
				fill='white'
			/>
		</svg>
	);
};

export default Usdt;
